// COLORS
export const MAIN_COLOR = '#EE097E';
export const WHITE_COLOR = '#FFFFFF';
export const GREY_COLOR = '#3b3b3b';
export const LIGHT_GREY_COLOR = '#f0f0f0';

// FONT SIZES
export const SMALL_TEXT = '18px';
export const MEDIUM_TEXT = '24px';
export const LARGE_TEXT = '48px';

//SCREEN SIZES
export const MOBILE_SIZE = '480px';
export const TABLET_SIZE = '768px';
export const LAPTOP_SIZE = '1024px';
export const DESKTOP_SIZE = '1140px';

export const QUERY_PARAMS = [
  'search',
  'minPlayers',
  'maxPlayers',
  'minAge',
  'maxAge',
  'categories',
];

//ABOUT PAGE
export { ABOUT_PAGE_PARAGRAPHS, ABOUT_PAGE_IMAGES } from './aboutPageInfo';



// WEBPACK FOOTER //
// constants/index.js